






























import { Vue, Prop, Component } from 'vue-property-decorator';
import { TextValuePair } from '@/models/TextValuePair';
@Component
export default class DropDownMultiSelect extends Vue {
    @Prop({ default: () => [] }) options!: TextValuePair[];
    @Prop({ default: () => false }) hideValue!: boolean;
    @Prop() label!: string;
    @Prop() value!: string[];
    selectedValues: string[] = [];
    expanded: boolean = false;

    formatText(text: string, value: string): string {
        if (this.hideValue) {
            return text;
        } else {
            return text + ' (' + value + ')';
        }
    }

    get selectedText(): string {
        if (this.selectedValues !== undefined && this.selectedValues.length > 0 && this.options.length > 0) {
            let selectedItems: string = '';
            for (let a = 0; a < this.selectedValues.length; a++) {
                const findVal = this.selectedValues[a];
                const foundVal = this.options.find((o: any) => o.value === findVal);
                if (foundVal !== undefined && foundVal.text !== undefined) {
                    selectedItems = foundVal.text + ', ' + selectedItems;
                }
            }
            if (selectedItems !== '') {
                return selectedItems.slice(0, -2);
            } else {
                return this.label;
            }
        } else {
            return this.label;
        }
    }

    private existsInArray(arr: string[], val: string): boolean {
        if (arr === undefined) {
            return false;
        }
        return arr.some(function(arrVal) {
            return val === arrVal;
        });
    }

    private unexpand(e: FocusEvent) {
        if (e.relatedTarget == null || !this.$el.contains(e.relatedTarget as Node)) {
            this.expanded = false;
        }
    }

    private expand() {
        if (this.options.length > 0) {
            this.expanded = !this.expanded;
        }
    }

    private selectOption(payload: TextValuePair) {
        if (!this.existsInArray(this.selectedValues, payload.value)) {
            this.selectedValues.push(payload.value);
        } else {
            this.selectedValues = this.selectedValues.filter(e => e !== payload.value);
        }
        this.$emit('input', this.selectedValues);
        //this.$emit('change', this.selectedValues);
    }
}
